import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const AnimalsEyeReviewIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M14.158 7.68001C13.7614 7.68001 13.4399 7.35846 13.4399 6.96188V0.959961H4.71923C4.23361 0.959961 3.83984 1.3537 3.83984 1.84028V21.6796C3.83984 22.1662 4.23546 22.56 4.72297 22.56H19.2768C19.7643 22.56 20.1599 22.1634 20.1599 21.6778V7.68001H14.158ZM11.9999 17.28C14.3858 17.28 16.3199 14.4 16.3199 14.4C16.3199 14.4 14.3858 11.52 11.9999 11.52C9.61393 11.52 7.67987 14.4 7.67987 14.4C7.67987 14.4 9.61393 17.28 11.9999 17.28ZM11.9999 16.32C13.0602 16.32 13.9199 15.4603 13.9199 14.4C13.9199 13.3397 13.0602 12.48 11.9999 12.48C10.9395 12.48 10.0799 13.3397 10.0799 14.4C10.0799 15.4603 10.9395 16.32 11.9999 16.32ZM11.9999 15.36C12.5305 15.36 12.9599 14.9306 12.9599 14.4C12.9599 13.8694 12.5305 13.44 11.9999 13.44C11.4693 13.44 11.0399 13.8694 11.0399 14.4C11.0399 14.9306 11.4693 15.36 11.9999 15.36ZM20.1599 6.72001H14.8808C14.6155 6.72001 14.3999 6.50438 14.3999 6.23907V0.960033L20.1599 6.72001Z'
                fill='currentColor'
            />
        </>
    ),
})

AnimalsEyeReviewIcon.displayName = 'AnimalsEyeReviewIcon'
